import type { CompactCollectionsModuleFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import type {
  CompactCollectionSetType,
  CompactCollectionsModuleRendererProps,
} from 'bundles/front-page/redesign-modules/compact-collections/CompactCollectionsModuleRenderer';

const normalizeCompactCollectionModuleContent = (
  content: CompactCollectionsModuleFragment
): CompactCollectionsModuleRendererProps | null => {
  const { title, collectionDataCollection } = content;

  const collections = collectionDataCollection?.items
    ?.map((item) => {
      if (!item) return null;
      const {
        title: itemTitle,
        target,
        presetCollectionId,
        collectionModuleId,
        collectionName,
        collectionFacets,
      } = item;

      if (!collectionModuleId) return null;

      let collection: CompactCollectionSetType;

      if (presetCollectionId) {
        collection = {
          id: `${collectionModuleId}-${presetCollectionId}`,
          collectionModuleId,
          presetCollectionId,
        };
      } else if (collectionName) {
        const facets = collectionFacets?.length ? [collectionFacets.filter(Boolean)] : undefined;
        const collectionId = facets
          ? `${collectionModuleId}-${collectionName}-${facets?.[0]?.map((facet) => facet?.split(':')[1])?.join('-')}`
          : `${collectionModuleId}-${collectionName}`;
        collection = {
          id: collectionId.toLocaleLowerCase(),
          collectionModuleId,
          collectionName,
          facets,
        };
      } else {
        return null;
      }

      return {
        headline: itemTitle ?? '',
        headlineTarget: target ?? '',
        collection,
      };
    })
    .filter(Boolean);

  return {
    headline: title ?? '',
    collections: collections ?? [],
  };
};

export default normalizeCompactCollectionModuleContent;
